import { ChangeDetectorRef, Directive, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { HomeDeeplinkType } from '@shared/home-sections/entities/home-data.response';
import { deeplinkClick } from '@home/mappers/home.mapper';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { IMAGE_HERO_URL, IMAGE_TYPE, URL_HERO_FOLDER } from '@ux/components/image/constants/image-type.constants';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';
import { GenericCardSpaces } from '@design-system/components/templates/generic-card/entities/generic-card.types';

@Directive()
export abstract class SlideAbstractComponent {

  @Input() branchCode: string;
  @Input() source: EVENT_SOURCE;
  @Input() salesChannel: string = null;

  @Output() htmlAnchor: EventEmitter<string> = new EventEmitter<string>();
  @Output() htmlExternal: EventEmitter<string> = new EventEmitter<string>();

  public showl = false;
  public showr = false;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly genericCardSpaces = GenericCardSpaces;

  constructor(
    protected router: Router,
    protected changeDetector: ChangeDetectorRef,
    protected imageCdnPipe: ImageCdnPipe,
  ) { }

  get fallbackImg(): string {
    return this.imageCdnPipe.baseImage(IMAGE_HERO_URL[IMAGE_TYPE.HOTEL], URL_HERO_FOLDER);
  }

  public selectSlide(deeplink: string, deeplinkType: HomeDeeplinkType): void {
    if (deeplinkType === HomeDeeplinkType.HTMLAnchor) {
      this.htmlAnchor.emit(deeplink);
    } else if (deeplinkType === HomeDeeplinkType.External) {
      this.htmlExternal.emit(deeplink);
    } else {
      deeplinkClick(deeplink, deeplinkType, this.router, this.salesChannel, this.source, this.branchCode);
    }
  }

}
